var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bromierung-benzol"},[_c('ul',[_c('li',[_vm._v("elektrophile Substitution")]),_c('li',[_vm._v("mit Katalysator")])])])}]

export { render, staticRenderFns }